import React from "react";

import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Copy } from "./copy.svg";
import { ReactComponent as Delete } from "./delete.svg";
import { ReactComponent as Help } from "./help.svg";
import { ReactComponent as Home } from "./home.svg";
import { ReactComponent as Move } from "./move.svg";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as QrScanner } from "./qr_scanner.svg";
import { ReactComponent as Reference } from "./reference.svg";
import { ReactComponent as Settings } from "./settings.svg";
import { ReactComponent as Search } from "./search.svg";
import { ReactComponent as Arrow } from "./arrow.svg";
import { ReactComponent as Info } from "./info.svg";
import { ReactComponent as Sms } from "./sms.svg";
import { ReactComponent as Coins } from "./coins.svg";
import { ReactComponent as Printer } from "./printer.svg";
import { ReactComponent as Galochka } from "./galochka.svg";
import { ReactComponent as Documents } from "./documents.svg";
import { ReactComponent as Box } from "./box.svg";
import { ReactComponent as ReferenceActive } from "./reference_active.svg";
import { ReactComponent as Refresh } from "./refresh.svg";
import { ReactComponent as Edit } from "./edit.svg";
import { ReactComponent as Send } from "./send.svg";
import { ReactComponent as Cancel } from "./cancel.svg";
import { ReactComponent as TickBlack } from "./tick_black.svg";
import { ReactComponent as Print } from "./print.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as Excel } from "./excel.svg";
import { ReactComponent as Logout } from "./logout.svg";

export const icons = {
  close: Close,
  copy: Copy,
  delete: Delete,
  help: Help,
  home: Home,
  move: Move,
  plus: Plus,
  qrScanner: QrScanner,
  reference: Reference,
  settings: Settings,
  search: Search,
  arrow: Arrow,
  info: Info,
  coins: Coins,
  printer: Printer,
  sms: Sms,
  galochka: Galochka,
  referenceActive: ReferenceActive,
  documents: Documents,
  box: Box,
  refresh: Refresh,
  edit: Edit,
  send: Send,
  cancel: Cancel,
  tickBlack: TickBlack,
  print: Print,
  download: Download,
  excel: Excel,
  logout: Logout,
};

export const Icon = ({ type, size = 15, ...rest }) => {
  const SelectedIcon = icons[type];
  if (!SelectedIcon) return null;

  return <SelectedIcon width={size} height={size} {...rest} />;
};
